import React from 'react';
import { Check } from 'react-feather';
import styles from './Icons.modules.scss';

interface IProps {
  className?: string;
}

export const CheckCircle = ({ className }: IProps) => (
  <div className={classnames(styles.circle, className)}>
    <Check
      className={styles.check}
      size={14}
      strokeWidth={4}
      strokeLinecap="square"
    />
  </div>
);
